import fetch from "auth/FetchInterceptor";

const objectiveActionPlansService = {};

objectiveActionPlansService.get = function (params = {}) {
	return fetch({
		url: `/v1/rest/objectives-action-plans/`,
		method: "get",
		params,
	});

	// return (
	// 	[
	// 		...Array(30).keys()
	// 	].map((i) => ({
	// 		id: i,
	// 		nome: `Setor ${i}`,
	// 	}))
	// );
};

objectiveActionPlansService.post = function (data) {
	return fetch({
		url: "/v1/rest/objectives-action-plans",
		method: "post",
		data: data,
	});
};

objectiveActionPlansService.postCopyObjective = function (data, company_id) {
	return fetch({
		url: `/v1/rest/objectives-action-plans-in-company-schema/${company_id}`,
		method: "post",
		data: data,
	});
};

objectiveActionPlansService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/objectives-action-plans/${id}`,
		method: "put",
		data: data,
	});
};

objectiveActionPlansService.getById = function (id) {
	return fetch({
		url: `/v1/rest/objectives-action-plans/${id}`,
		method: "get",
	});
};

// Novo método para objetivos inativos
objectiveActionPlansService.getInactives = function (params = {}) {
	return fetch({
		url: "/v1/rest/objectives-action-plans-inactives",
		method: "get",
		params,
	});
};

export default objectiveActionPlansService;
